module.exports = __webpack_public_path__ + "static/img/haevichi-thumb.ba0d5e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/haevichi-thumb.jpg
// module id = ZlrS
// module chunks = 0